module.exports = __webpack_public_path__ + "img/ORDER-JP.0946cfe2.png";